
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partners/webinar-by-kc-admission-experts",
      function () {
        return require("private-next-pages/partners/webinar-by-kc-admission-experts.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partners/webinar-by-kc-admission-experts"])
      });
    }
  